import React from 'react'
import { PageContent, PageFooter, Message, Text, Heading } from 'components/library'
import audio01 from './assets/Sleper_Oproep.mp3'
import audio02 from './assets/APC_antwoord.mp3'
import audio03 from './assets/Sleper_Aanvraag.mp3'
import audio04 from './assets/APC_Klaring.mp3'
import audio05 from './assets/Sleper_KLaring_teruglezen.mp3'
import audio06 from './assets/Sleper_afmelden.mp3'
import audio07 from './assets/APC_Sluiten.mp3'
import audio08 from './assets/Sleper_afsluiten.mp3'
import './Aspect01.css'

class Aspect01 extends React.Component {

  render() {
    return (
      <div className="Chapter05-Aspect01">
        <PageContent>
          <div>

            <Message task icon="play">
              <Text>Beluister onderstaande fragmenten om voorbeelden te horen van standaardberichten</Text>
            </Message>

            <div className="has-two-col Heading-row">
              <div className="col-01">
                <Heading h2>Proces</Heading>
              </div>
              <div className="col-02">
                <Heading h2>Standaardbericht</Heading>
              </div>
            </div>

            <div className="has-two-col">
              <div className="col-01">
                <Text>1. Aanvragen Sleepbeweging</Text>
                <br/>
                <Text>Jij doet de aanvraag voor een sleepbeweging. Als je een sleepbeweging aanvraagt dien je altijd een van de volgende uitdrukkingen te gebruiken: 'bestemming', 'mag', of 'wil'.</Text>
              </div>
              <div className="col-02">
                <div>
                  <div>
                    <Text><strong>Sleper oproep</strong></Text>
                    <Text>Apron-Noord/-Zuid + je volledige registratie + positie</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio01} type="audio/ogg"/>
                      <source src={audio01} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
                <div className="has-background-color">
                  <div>
                    <Text><strong>Apron Control antwoord</strong></Text>
                    <Text>Je verkorte registratie + Apron-Noord/-Zuid</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio02} type="audio/ogg"/>
                      <source src={audio02} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
                <div>
                  <div>
                    <Text><strong>Sleper aanvraag</strong></Text>
                    <Text>Je verkorte registratie + positie + bestemming of verzoek + trekkerbenaming</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio03} type="audio/ogg"/>
                      <source src={audio03} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
              </div>
            </div>

            <div className="has-two-col">
              <div className="col-01">
                <Text>2. Klaring</Text>
                <br/>
                <Text>Apron Control geeft klaring (toestemming) voor het uivoeren van de sleepbeweging. De klaring omvat eventueel de rijroute en/of aanvullende opdrachten of informatie.</Text>
              </div>
              <div className="col-02">
                <div>
                  <div>
                    <Text><strong>Apron Control klaring</strong></Text>
                    <Text>Je verkorte registratie + trekkerbenaming + toestemming/route/klarinsglimiet (tot...)</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio04} type="audio/ogg"/>
                      <source src={audio04} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
              </div>
            </div>

            <div className="has-two-col">
              <div className="col-01">
                <Text>3. Teruglezen klaring &amp; uitvoeren aanvraag</Text>
                <br/>
                <Text>Na ontvangst van de klaring van Apron Control dien je de verkregen toestemming, de rijroute en/of opdracht terug te lezen (te herhalen). Dit geldt ook voor de opdracht wachten. Pas als je dit hebt teruggelezen mag je beginnen met het uitvoeren van de aanvraag.<br/><br/>Informatie die geen klaring of opdracht bevat kunt je beantwoorden met de enkele uitdrukking ‘begrepen’. </Text>
              </div>
              <div className="col-02">
                <div>
                  <div>
                    <Text><strong>Sleper teruglezen</strong></Text>
                    <Text>Je verkorte registratie + klaring herhalen</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio05} type="audio/ogg"/>
                      <source src={audio05} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
              </div>
            </div>

            <div className="has-two-col">
              <div className="col-01">
                <Text>4. Melden na aankomst</Text>
                <br/>
                <Text>Als je bent aangekomen op de plaats van bestemming, meld je dit aan Apron Control. Hierna krijg je de opdracht de verbinding te sluiten.</Text>
              </div>
              <div className="col-02">
                <div>
                  <div>
                    <Text><strong>Sleper afmelden</strong></Text>
                    <Text>Je verkorte registratie + aangekomen + bestemming</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio06} type="audio/ogg"/>
                      <source src={audio06} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
                <div className="has-background-color">
                  <div>
                    <Text><strong>Apron Control antwoord</strong></Text>
                    <Text>Je verkorte registratie + sluiten</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio07} type="audio/ogg"/>
                      <source src={audio07} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
                <div>
                  <div>
                    <Text><strong>Sleper Afmelden</strong></Text>
                    <Text>Je verkorte registratie + sluiten</Text>
                  </div>
                  <div>
                    <audio controls controlsList="nodownload">
                      <source src={audio08} type="audio/ogg"/>
                      <source src={audio08} type="audio/mpeg"/>
                    </audio>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </PageContent>
        <PageFooter>
          <Message info title="Gebruik roepnaam">
            <Text>Het kan voorkomen dat Apron Control na jou eerste oproep het initiatief neemt  om gebruik te maken van een verkorte roepnaam. Dit is zijn de laatste drie letters van je volledige vliegtuigregistratie. Wanneer Apron Control dit doet, gebruik jij in de verdere communicatie ook de verkorte roepnaam.<br/><br/><strong>Sleper zonder vliegtuig</strong><br/>Als je geen vliegtuig sleept gebruik je het tweeletterige vliegtuigtrekker-callsign in plaats van de vliegtuigregistratie.</Text>
          </Message>
        </PageFooter>
      </div>
    )
  }
}

export default Aspect01



// WEBPACK FOOTER //
// ./src/content/chapters/05/01/Aspect01.js